import { useAuth0 } from '@auth0/auth0-react';
import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import { useLogin } from '#src/hooks/auth.tsx';

export const LoginLogoutMenuItemWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { logout, isAuthenticated } = useAuth0();
  const { login } = useLogin();
  return (
    <Box
      id="logout-wrapper"
      cursor="pointer"
      onClick={async (e) => {
        e.stopPropagation();
        if (!isAuthenticated) {
          await login({});
        } else {
          await logout({ logoutParams: { returnTo: window.location.origin } });
        }
      }}
    >
      {children}
    </Box>
  );
};

export const LoginLogoutMenuItemLabel = () => {
  const { isAuthenticated } = useAuth0();
  return isAuthenticated ? 'Log out' : 'Sign in';
};
